<template>
  <div class="animated fadeIn">
    <basic-heading title="Test Packages" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list test package'">
      <template #gated-content>
        <test-package-server-table @deleteTestPackage="deleteTestPackage" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestPackageServerTable from "@/components/lab/testpackage/TestPackageServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";

Vue.use(VueNotifications, notificationOptions);

const TestPackageRepository = LabRepositoryFactory.get("testPackage");

export default {
  name: "TestPackageIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageServerTable,
  },
  data() {
    return {
      test_packages: [],
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/testpackages/add",
            variant: "success",
            title: "Add test package",
            permission: this.checkPermission("add test package"),
          },
        ],
        dropdown: {
          items: [
            {
              icon: "fa-sort",
              linkto: "/testpackages/sort",
              text: "Sort test packages",
              variant: "info",
            },
            {
              icon: "fa-sort",
              linkto: "/testpackages/group-sort",
              text: "Sort test packages groups",
              variant: "info",
            },
            {
              icon: "fa-layer-group",
              linkto: "/testpackagegroups",
              text: "Manage Test Package Groups",
              variant: "info",
            },
          ],
        },
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    deleteTestPackage(id) {
      new Promise((resolve, reject) => {
        TestPackageRepository.suspend(id)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
      })
        .then(() => {
          for (let index in this.test_packages) {
            let testpackage = this.test_packages[index];
            if (testpackage && testpackage.id && testpackage.id === id) {
              this.test_packages.splice(index, 1);
            }
          }
          this.deleteSuccess();
        })
        .catch(() => {
          this.deleteFail();
        });
    },
  },
};
</script>
